"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPartnerArticleApiClient = createPartnerArticleApiClient;
const index_const_1 = require("../index.const");
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function createPartnerArticleApiClient(apiHost, options) {
    const logger = options.logger ?? index_const_1.NOOP_LOGGER;
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function createArticle(partnerId, article) {
        try {
            const response = await client.post(`/v2/partners/${partnerId}/articles`, article);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function findAllArticlesByPartnerId(partnerId) {
        try {
            const response = await client.get(`/v2/partners/${partnerId}/articles`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function findOneArticleByPartnerIdAndSlug(partnerId, slug) {
        try {
            const response = await client.get(`/v2/partners/${partnerId}/articles/${slug}`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    // returns nothing with status_code : 204
    async function updateArticleByPartnerIdAndSlug(partnerId, slug, article) {
        try {
            const response = await client.post(`/v2/partners/${partnerId}/articles/${slug}`, article);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function deleteArticle(partnerId, slug) {
        try {
            const response = await client.delete(`/v2/partners/${partnerId}/articles/${slug}`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function findAnchoredArticleByPartnerId(partnerId) {
        try {
            const response = await client.get(`/v2/partners/${partnerId}/anchored-article`);
            return response.data;
        }
        catch (err) {
            if (err.response.status === 404)
                return null;
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    return {
        createArticle,
        findAllArticlesByPartnerId,
        findOneArticleByPartnerIdAndSlug,
        updateArticleByPartnerIdAndSlug,
        deleteArticle,
        findAnchoredArticleByPartnerId
    };
}
//# sourceMappingURL=data:application/json;base64,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